// Knock Doorway client-side initialization
// Loaded separately from the blocking script tag injected via gatsby-ssr.js

const KNOCK_APP_KEY = '4ebcfda04f8311ebb3c20219e8bcf0b7'
const KNOCK_CHANNEL = 'community'
const KNOCK_WORKFLOW = '730211f03b53256c'

function initKnock () {
  if (typeof window === 'undefined') return
  const lib = window.knockDoorway
  if (!lib || !lib.init) return false
  if (window.__knockDoorwayInitialized) return true
  try {
    lib.init(KNOCK_APP_KEY, KNOCK_CHANNEL, KNOCK_WORKFLOW)
    window.__knockDoorwayInitialized = true

    console.debug('[Knock] doorway initialized')
    return true
  } catch (e) {
    console.error('[Knock] init failed:', e)
  }
  return false
}

function scheduleRetry (attempt = 1) {
  if (attempt > 10) return
  const delay = Math.min(1000 * attempt, 4000) // backoff cap 4s
  setTimeout(() => {
    if (!initKnock()) scheduleRetry(attempt + 1)
  }, delay)
}

export const onClientEntry = () => {
  if (initKnock()) return

  // Listen for the script load if it's still pending
  const loader = document.getElementById('knock-doorway-loader')
  if (loader) {
    loader.addEventListener('load', () => {
      if (!initKnock()) scheduleRetry()
    }, { once: true })
  } else {
    // If element not found yet (very early), wait a tick then retry & schedule
    setTimeout(() => {
      if (!initKnock()) scheduleRetry()
    }, 0)
  }
}

export const onInitialClientRender = () => {
  document.documentElement.style.visibility = 'visible'
}
